import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import {
  type TrendDirection,
  type MetricPolarity,
  trendSentiment,
  SENTIMENT_TEXT,
  DIRECTION_LABEL,
} from '../lib/trend';

/**
 * Shared arrow + label for any metric with a direction. The caller declares
 * the metric's polarity; colour is derived from direction x polarity — never
 * from direction alone. Unknown renders with no arrow so absence of data
 * cannot masquerade as stability.
 */
export function TrendIndicator({
  direction,
  polarity,
  className = '',
}: {
  direction: TrendDirection;
  polarity: MetricPolarity;
  className?: string;
}) {
  const sentiment = trendSentiment(direction, polarity);
  const Icon =
    direction === 'up' ? TrendingUp :
    direction === 'down' ? TrendingDown :
    direction === 'flat' ? Minus :
    null;

  return (
    <span
      className={`inline-flex items-center justify-center gap-1 text-meta font-medium ${SENTIMENT_TEXT[sentiment]} ${className}`}
    >
      {Icon && <Icon className="h-4 w-4" aria-hidden="true" />}
      {DIRECTION_LABEL[direction]}
    </span>
  );
}
